import { APIPaths } from "@/apis/api-config";

import BaseApi from "../base-api";

export class PartnerApi extends BaseApi {
  async getPartnerMe(): Promise<
    APIPaths["/partner-app/partner/me"]["get"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.get("/partner-app/partner/me")).data;
  }
  async patchPartnerById(
    requestBody: APIPaths["/partner-app/partner/me"]["patch"]["requestBody"]["content"]["application/json"],
  ): Promise<APIPaths["/partner-app/partner/me"]["patch"]["responses"]["200"]["content"]["application/json"]> {
    return (await this.patch("/partner-app/partner/me", requestBody)).data;
  }
  async putPartnerMePassword(
    requestBody: APIPaths["/partner-app/partner/me/password"]["put"]["requestBody"]["content"]["application/json"],
  ): Promise<APIPaths["/partner-app/partner/me/password"]["put"]["responses"]["200"]["content"]["application/json"]> {
    return (await this.put("/partner-app/partner/me/password", requestBody)).data;
  }
}
